import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const andheri: AreaConfig = {
  name: 'Andheri',
  slug: 'andheri',
  tagline: 'Doorstep Mobile Repair in Andheri, Mumbai',
  description:
    'Cracked screen, dead battery, or charging issue? minto sends a certified technician to your home or office in Andheri East or West. Most repairs done in under an hour — no shop visit needed.',
  localities: [
    'Andheri East', 'Andheri West', 'Lokhandwala', 'Versova', 'DN Nagar',
    'J.B. Nagar', 'Marol', 'MIDC', 'Chakala', 'Sher-E-Punjab',
    'SEEPZ', 'Oshiwara', 'Four Bungalows', 'Seven Bungalows', 'Jogeshwari',
  ],
  zones: [
    {
      name: 'Lokhandwala & Versova',
      line: 'Western Line',
      station: 'Andheri West Station',
      localities: ['Lokhandwala Complex', 'Lokhandwala Market', 'Four Bungalows', 'Seven Bungalows', 'Versova', 'Oshiwara', 'DN Nagar', 'Gilbert Hill'],
      desc: 'Covering the prime residential zones of Andheri West. Technician reachable within 45–60 minutes anywhere in Lokhandwala or Versova.',
    },
    {
      name: 'MIDC, Marol & Corporate Belt',
      line: 'Western Line',
      station: 'Andheri East Station / Chakala Metro',
      localities: ['MIDC', 'Marol', 'J.B. Nagar', 'Chakala', 'SEEPZ', 'Sher-E-Punjab', 'Andheri East', 'Airport Zone'],
      desc: 'Serving offices, IT parks and residential complexes of Andheri East. We repair phones at your desk without disturbing your work.',
    },
    {
      name: 'Jogeshwari & Oshiwara',
      line: 'Western Line',
      station: 'Jogeshwari Station',
      localities: ['Jogeshwari West', 'Jogeshwari East', 'Oshiwara', 'Film City Road', 'Andheri Link Road'],
      desc: 'Adjacent to Andheri, our Jogeshwari coverage ensures fast doorstep service for residents near the Western Express Highway.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Andheri | Doorstep Phone Repair Service | minto',
    description:
      'Expert doorstep mobile repair in Andheri East & West, Mumbai. Screen replacement, battery repair, charging port fix. Certified technicians, 90-day warranty. Starting ₹299. Book now!',
    keywords:
      'mobile repair Andheri, phone repair Andheri, screen repair Andheri, battery replacement Andheri, doorstep mobile repair Andheri, iPhone repair Andheri, Samsung repair Andheri, mobile repair Andheri East, mobile repair Andheri West, Lokhandwala phone repair, Versova mobile repair, MIDC phone repair, Marol mobile repair',
  },
  faqs: [
    {
      q: 'Do you offer doorstep mobile repair in Andheri East?',
      a: 'Yes, we cover all of Andheri East including Marol, MIDC, Chakala, J.B. Nagar, and SEEPZ. A technician arrives within 60–90 minutes of booking.',
    },
    {
      q: 'How much does screen repair cost in Andheri?',
      a: 'Screen repair starts from ₹999 depending on your phone model. Select your device on the booking page to see the exact price — no hidden charges.',
    },
    {
      q: 'Do you cover Lokhandwala and Versova in Andheri West?',
      a: 'Yes! We cover all of Andheri West including Lokhandwala, Versova, Oshiwara, DN Nagar, Four Bungalows, and Seven Bungalows.',
    },
    {
      q: 'How long does a doorstep repair take in Andheri?',
      a: 'Most repairs like screen replacement and battery replacement are completed in 45–60 minutes at your location in Andheri.',
    },
    {
      q: 'Is there a warranty on repairs done in Andheri?',
      a: 'Yes, all repairs come with a 90-day warranty. If the same issue reoccurs within 90 days, we fix it free of charge.',
    },
  ],
};

const AndheriPage: React.FC = () => <AreaLandingPage area={andheri} />;
export default AndheriPage;
